import React from "react";

import NoResults from "../../../../common/NoResults";
import { SonicEventData } from "../../../../common/classes/SonicEvent";
import ActionBtn from "../../../../common/management/ActionBtn";

import { timestampToTime } from "../../../../utils/GeneralUtils";

import styles from "../../../management/db-list/DBList.module.scss";

type Props = {
  events: Array<SonicEventData>;
  isSelect: boolean;
  owners: { email: string; roles: string[]; full_name?: string }[];
};

const ReleaseEventList: React.FC<Props> = ({ events, isSelect, owners }) => {
  if (events.length === 0) return <NoResults />;

  return (
    <div className={styles["f-dbList"]}>
      <div
        className={`${styles["f-dbList__category"]} ${styles["head"]} ${styles["release"]}`}
      >
        <div>イベント名</div>
        <div>イベントカテゴリ</div>
        <div>作成者名</div>
        <div>申請日時</div>
        <div>アクション</div>
      </div>
      {events.map((event, i) => (
        <div
          className={`${styles["f-dbList__category"]} ${styles["body"]} ${styles["release"]}`}
          key={i}
        >
          <div>{event.name}</div>
          <div>{event.event_type?.name}</div>
          <div>
            {!isSelect && owners[i].full_name ? owners[i].full_name : event.owner_name}
          </div>
          <div>{timestampToTime(event.application_date, true)}</div>
          <ActionBtn
            label="対応する"
            icon={["fal", "edit"]}
            link={
              isSelect
                ? `/admin/event/release/${event.id}`
                : `/jikei/event/release/${event.id}`
            }
          />
        </div>
      ))}
    </div>
  );
};

export default ReleaseEventList;
